import { acFilterTypes } from '../acReduxExports'


export const chargingHistoryReportInitialFilterValues: AcInnerFilterState[] = [
  {
    key:'chargingStationId',
    value:null
  },
  {
    key: 'chargerId',
    value: null
  },
  {
    key:'productType',
    value:null
  },
  {
    key: 'chargingHistoryInterval',
    value: null
  }
]

export const chargingSessionTrendInitialFilterValues: AcInnerFilterState[] = [
  {
    key: 'chargerId',
    value: null
  },
  {
    key:'chargingStationId',
    value:null
  },
  {
    key: 'sessionChargingIntervalRange',
    value: [
      {
        id: 'lastWeek',
        value: 'lastWeek',
        label: 'Last Week',
        name: 'Last Week'
      }
    ]
  },
]

export const chargerInitialFilterValues: AcInnerFilterState[] = [
  {
    key: 'chargerType',
    value: null
  },
  {
    key: 'location',
    value: null
  },
  {
    key: 'chargerStatus',
    value: null
  },
  {
    key: 'softwareVersion',
    value: null
  },
  {
    key:'ccuVersion',
    value:null
  },
  {
    key: 'alarmStatus',
    value: null
  },
  {
    key: 'visibility',
    value: null
  },
  {
    key:'chargingStationId',
    value:null
  }  ,
  {
    key:'productType',
    value:null
  },
  {
    key:'activeCertificate',
    value:null
  }
]

export const updateCommandslInitialFilterValues: AcInnerFilterState[] = [
  {
    key: 'userRemoteCommand',
    value: null
  },
  {
    key: 'setIntervalUpdateCommand',
    value: null
  },
]

export const exceptionLogsReportInitialFilterValues: AcInnerFilterState[] = [
  {
    key: 'chargerId',
    value: null,
  },
  {
    key: 'logSeverity',
    value: null
  },
  {
    key: 'logInterval',
    value: null
  }
]


export const chargingVsIdleInitialFilterValues: AcInnerFilterState[] = [
  {
    key: 'chargerId',
    value: null
  },
  {
    key:'chargingStationId',
    value:null
  },
  {
    key: 'idleChargingIntervalRange',
    value: [
      {
        id: 'lastWeek',
        value: 'lastWeek',
        label: 'Last Week',
        name: 'Last Week'
      }
    ]
  },
]

export const overallUptimeInitialFilterValues: AcInnerFilterState[] = [
  {
    key: 'chargerId',
    value: null
  },
  {
    key:'chargingStationId',
    value:null
  },
  {
    key: 'uptimeIntervalRange',
    value: [
      {
        id: 'lastWeek',
        value: 'lastWeek',
        label: 'Last Week',
        name: 'Last Week'
      }
    ]
  },
]

export const nocDashboardInitialFilterValues:AcInnerFilterState[] = [
    {
    key: 'mapDefaultView',
    value:[
      {
        id:'chargingSessions',
        label:'chargingSessions',
        name:'chargingSessions',
        value:'chargingSessions'
      }
    ]
  },
  {
    key:'nocChargerStatus',
    value:[]
  },
  {
    key: 'nocChargerRmsStatus',
    value: []
  },
  {
    key: 'nocChargerCmsConnectivity',
    value: []
  },
  {
    key: 'nocChargerAlarms',
    value: []
  },
  {
    key: 'nocChargerChargingStatus',
    value: []
  },
  {
    key: 'nocAlarmHealthStatus',
    value:[]
  },
  {
    key: 'nocChargerHealthStatus',
    value: []
  },
  {
    key:'productType',
    value:null
  },
  {
    key:'timeSelection',
    value:null
  }
]



export const configureNotificationInitialFilterValues: AcInnerFilterState[] = [
  {
    key: 'alarmSeverity',
    value: null
  },
  {
    key: 'alarmTypeId',
    value: null
  },
  {
    key: 'typeOfNotification',
    value: null
  },
  {
    key: 'stopReasonCode',
    value: null
  },
  {
    key: 'alarmRuleCreatedBy',
    value: null
  },
  {
    key: 'alarmRuleUpdatedBy',
    value: null
  },
  {
    key: 'alarmRuleCreatedAtInterval',
    value: null,
  },
  {
    key:'alarmRuleUpdatedAtInterval',
    value: null
  }
]

export const configureNotificationHistoryInitialFilterValues : AcInnerFilterState[] = [
  {
    key: 'chargingStationId',
    value: null,
  },
  { 
    key: 'ruleId',
    value: null,
  },
  {
    key: 'chargerId',
    value: null,
  },
  {
    key: 'alarmSeverity',
    value: null
  },
  {
    key: 'alarmTypeId',
    value: null,
  },
  {
    key: 'stopReasonCode',
    value: null
  },
  {
    key: 'typeOfNotification',
    value: null
  },
  {
    key: 'fireTime',
    value: null
  },
]

// export const acChargerPanelInitialFilterValues: AcInnerFilterState[] = [
// 	{
// 		key: 'historyType',
// 		value: [
// 			{
// 				id: 'R Phase Voltage',
// 				value: 'R Phase Voltage',
// 				label: 'R Phase Voltage',
// 				name: 'R Phase Voltage',
// 				defaultOption: true,
// 				statType: [
// 					{
// 						id: 'Average',
// 						value: 'Average',
// 						label: 'Average',
// 						name: 'Average',
// 						defaultOption: true,
// 					},
// 					{
// 						id: 'Minimum',
// 						value: 'Minimum',
// 						label: 'Minimum',
// 						name: 'Minimum',
// 						defaultOption: false,
// 					},
// 					{
// 						id: 'Maximum',
// 						value: 'Maximum',
// 						label: 'Maximum',
// 						name: 'Maximum',
// 						defaultOption: false,
// 					},
// 				],
// 				connectorType: [
// 				],
// 			},
// 		],
// 	},
// 	{
// 		key: 'statType',
// 		value: [
// 			{
// 				id: 'Average',
// 				value: 'Average',
// 				label: 'Average',
// 				name: 'Average',
// 			},
// 		],
// 	},
// 	{
// 		key: 'historyInterval',
// 		value: [
// 			{
// 				id: 'one_day',
// 				value: 'Last 24 hours',
// 				label: 'Last 24 hours',
// 				name: 'Last 24 hours',
// 				defaultOption: true,
// 				statInterval: [
// 					{
// 						id: '5_min',
// 						value: '5 minutes',
// 						label: '5 minutes',
// 						name: '5 minutes',
// 						defaultOption: true,
// 					},
// 					{
// 						id: '15_min',
// 						value: '15 minutes',
// 						label: '15 minutes',
// 						name: '15 minutes',
// 						defaultOption: false,
// 					},
// 					{
// 						id: '1_hour',
// 						value: '1 hour',
// 						label: '1 hour',
// 						name: '1 hour',
// 						defaultOption: false,
// 					},
// 					{
// 						id: '6_hour',
// 						value: '6 hours',
// 						label: '6 hours',
// 						name: '6 hours',
// 						defaultOption: false,
// 					},
// 					{
// 						id: '1_day',
// 						value: '1 day',
// 						label: '1 day',
// 						name: '1 day',
// 						defaultOption: false,
// 					},
// 				],
// 			},
// 		],
// 	},
// 	{
// 		key: 'statInterval',
// 		value: [
// 			{
// 				id: '5_min',
// 				value: '5 minutes',
// 				label: '5 minutes',
// 				name: '5 minutes',
// 			},
// 		],
// 	},
// 	{
// 		key: 'connectorId',
// 		value: [
// 		],
// 	},
// ];

export const acChargerPanelInitialFilterValues: AcInnerFilterState[] = [
  {
    key: 'historyType',
    value: null
  },
  {
    key: 'statType',
    value: null
  },
  {
    key: 'historyInterval',
    value: null

  },
  {
    key: 'statInterval',
    value: null
  },
  {
    key: 'connectorId',
    value: null
  }
]


export const alarmInitialFilterValues: AcInnerFilterState[] = [
  {
    key: 'chargerType',
    value: null
  },
  {
    key: 'severity',
    value: null
  },
  {
    key: 'alarmSetTimeStamp',
    value: null
  },
  {
    key: 'alarmClearedTimeStamp',
    value: null
  },
  {
    key: 'alarmType',
    value: null
  },
  {
    key: 'chargerId',
    value: null
  },
  {
    key:'chargerStatus',
    value:null
  },
  {
    key:'alarmState',
    value:null
  }
]

export const dashboardV2InitialFilterValues: AcInnerFilterState[] = [
  {
    key: 'productType',
    value: null
  },
  {
    key: 'sessionIntervalRange',
    value: [
      {
        id: 'lastWeek',
        value: 'lastWeek',
        label: 'Last Week',
        name: 'Last Week'
      }
    ]
  },
  {
    key: 'keyType',
    value: [{
      'id': 'criticalAlarms',
      'value': 'criticalAlarms',
      'label': 'criticalAlarms',
      'name': 'criticalAlarms'
    }]
  },
  {
    key: 'chargingSessionFetchType',
    value: null
  },
  {
    key: 'energyConsumptionIntervalRange',
    value: [
      {
        id: 'lastWeek',
        value: 'lastWeek',
        label: 'Last Week',
        name: 'Last Week'
      }
    ]
  },
  {
    key: 'offlineFiveDays',
    value: [
      {
        id: 'false',
        value: 'false',
        label: 'false',
        name: 'false'
      }
    ]
  },
  {
    key: 'energyEfficiencyRange',
    value: [
      {
        id: 'lastWeek',
        value: 'lastWeek',
        label: 'Last Week',
        name: 'Last Week'
      }
    ]
  },
  {
    key: 'reactiveEnergyRange',
    value: [
      {
        id: 'lastWeek',
        value: 'lastWeek',
        label: 'Last Week',
        name: 'Last Week'
      }
    ]
  },
]



export const customerChargerInitialFilterValues: AcInnerFilterState[] = [
  {
    key: 'location',
    value: null
  },
  {
    key: 'chargerStatus',
    value: null
  },
  {
    key: 'softwareVersion',
    value: null
  },
  {
    key: 'alarmStatus',
    value: null
  }
]

export const chargingStationsInitialFilterValues: AcInnerFilterState[] = [
  {
    key: 'location',
    value: null
  },
]






export const parametersInitialFilterValues: AcInnerFilterState[] = [
  {
    key: 'param',
    value: null
  },
  {
    key: 'user',
    value: null
  },
  {
    key: 'setInterval',
    value: null
  },

]

export const chargerLogsReportInitialFilterValues: AcInnerFilterState[] = [
  {
    key: 'chargerId',
    value: null,
  },
  {
    key: 'chargerLogStatusInterval',
    value: null
  },
  {
    key: 'chargerLogSettingInterval',
    value: null
  },
  {
    key: 'chargerLogSystemLogInterval',
    value: null
  }
]




export const latestChargerStatusLogsInitialFilterValues:AcInnerFilterState[]=[
  {
  key:'chargerId',
  value:null
  },
]

export const acSoftwareVersionDeploymentLogsInitialFilterValues: AcInnerFilterState[] = [
  {
    key: 'chargingStationId',
    value: null
  },
  {
    key: 'productType',
    value: null
  },
  {
    key: 'swVersionUpdateLogs',
    value: null
  },
  {
    key: 'swLogStatus',
    value: null
  },
  {
    key: 'swVersionRequestedOnInterval',
    value: null
  }
]

export const versionReleasesInitialFilterValues: AcInnerFilterState[] = [
  {
    key:'versionProductType',
    value:null
  },
  {
    key:'versionReleaseType',
    value:null
  },
  {
    key:'versionSeverity',
    value:null
  },
  {
    key:'versionClassification',
    value:null
  },
  {
    key:'versionReleaseDateInterval',
    value:null
  }
]




export const versionReleasesDashboardInitialFilterValues: AcInnerFilterState[] = [
  {
    key:'productType',
    value:[
      {
        id:'a7244551-49e5-4b0c-b370-17e41b32958f',
        name:'Spin Air LC',
        value:'a7244551-49e5-4b0c-b370-17e41b32958f',
        label:'Spin Air LC'
      }
    ]
  },
  {
    key:'softwareVersion',
    value:null
  },
  {
    key:'swVersionDateInterval',
    value:[{
        id: 'lastQuarter',
        value: 'lastQuarter',
        label: 'Last Quarter',
        name: 'Last Quarter'
      }]
  },
  {
    key:'swVersionReleaseType',
    value:[
      {
        id:'Enabled',
        value:'Enabled',
        label:'Enabled',
        name:'Enabled'
      }
    ],
  }
]


export const nocPerfomanceAnalyticsIntialFilterValues: AcInnerFilterState[] = [
  {
    key: 'chargingStationId',
    value: []
  },
  {
    key:'productType',
    value:[]
  },
  {
    key:'nocTimeSelectionInterval',
    value:[
       { label: 'Last 24hr', value: 'last24hr' }
    ]
  },
  {
    key:'chargerId',
    value:[]
  }
]


export const acUptimeReportsInitialFilterValues: AcInnerFilterState[] = [
  {
    key: 'productType',
    value: null
  },
  {
    key: 'chargingStationId',
    value: null
  },
  {
    key: 'acUptimeQuickDateRange',
    value:[
      {
          label: 'Last Day',
          value: '24H'
      }
    ]
  },
  {
    key: 'acUptimeReportDateRangeInterval',
    value: null
  }
]

export const statusHistoryReportInitialFilterValues: AcInnerFilterState[] = [
  {
    key: 'chargerId',
    value: null,
  },
]

export const acChargerCertificatesInfoInitialValues: AcInnerFilterState [] = [
  {
    key:'chargingStationId',
    value: null
  },
  {
    key: 'chargerId',
    value: null
  },
  {
    key: 'certificateGeneretedBy',
    value: null
  },
  {
    key: 'certificateCreatedAtInterval',
    value: null
  },
  {
    key: 'certificateExpiryIntervalRange',
    value: null
  },
  {
    key: 'chargerCertificateStatus',
    value: null
  },
  {
    key: 'productType',
    value: null
  },
]

export const screenFiltersInitialState: AcScreenFilterState[] = [
	{
		screen: 'acchargers',
		filters: chargerInitialFilterValues,
	},
	{
		screen: 'acalarms',
		filters: alarmInitialFilterValues,
	},
	{
		screen: 'acchargerPanel',
		filters: acChargerPanelInitialFilterValues,
	},
	{
		screen: 'acchargingHistoryReport',
		filters: chargingHistoryReportInitialFilterValues,
	},
	{
		screen: 'chargerLogsReport',
		filters: chargerLogsReportInitialFilterValues,
	},
	{
		screen: 'latestChargerStatusLogs',
		filters: latestChargerStatusLogsInitialFilterValues,
	},
	{
		screen: 'acdashboard',
		filters: dashboardV2InitialFilterValues,
	},
  {
      screen:'nocDashboard',
      filters:nocDashboardInitialFilterValues
  },
  {
     screen : 'nocPerfomanceAnalytics' ,
     filters: nocPerfomanceAnalyticsIntialFilterValues,
  },
	{
		screen: 'customerCharger',
		filters: customerChargerInitialFilterValues,
	},
	{
		screen: 'chargingStations',
		filters: chargingStationsInitialFilterValues,
	},
	{
		screen: 'parameters',
		filters: parametersInitialFilterValues,
	},
	{
		screen: 'updateCommands',
		filters: updateCommandslInitialFilterValues,
	},
	{
		screen: 'versionReleasesDashboard',
		filters: versionReleasesDashboardInitialFilterValues,
	},
	{
		screen: 'versionReleases',
		filters: versionReleasesInitialFilterValues,
	},
	{
		screen: 'chargingSessionTrend',
		filters: chargingSessionTrendInitialFilterValues,
	},
	{
		screen: 'exceptionLogsReport',
		filters: exceptionLogsReportInitialFilterValues,
	},
  {
      screen:'chargingVsIdle',
      filters:chargingVsIdleInitialFilterValues
  },
  {
      screen:'overallUptime',
      filters:overallUptimeInitialFilterValues
  },
  {
      screen: 'acConfigureNotification',
      filters: configureNotificationInitialFilterValues
  },
  {
      screen: 'acConfigureNotificationHistory',
      filters: configureNotificationHistoryInitialFilterValues
  },
  {
      screen: 'acSoftwareVersionDeploymentLogs',
      filters: acSoftwareVersionDeploymentLogsInitialFilterValues
  },
  {
      screen: 'acStatusHistoryReport',
      filters: statusHistoryReportInitialFilterValues
  },
  {
    screen: 'acUptimeReports',
    filters: acUptimeReportsInitialFilterValues
  },
  {
    screen: 'acChargerCertificates',
    filters: acChargerCertificatesInfoInitialValues
  }
  
];


export const globalFiltersInitialState: AcInnerFilterState[] = [
  {
    key: 'customer',
    value: null
  },
]

const filterInitialState: ACFilterDataState = {
  globalFilters: globalFiltersInitialState,
  screenFilters: screenFiltersInitialState,
};

const acfilterReducer = (state: ACFilterDataState = filterInitialState, action: ACFilterDataAction): ACFilterDataState => {
  switch (action.type) {
    case acFilterTypes.SET_GLOBAL_AC_FILTERS_DATA:
      return {
        ...state,
        globalFilters: action.globalFilters,
      };

    case acFilterTypes.SET_SCREEN_AC_FILTERS_DATA:
      return {
        ...state,
        screenFilters: action.screenFilters,
      };
    default:
      return state;
  }
};


export default acfilterReducer;